import { useMutation } from "@tanstack/react-query";
import { sendInvitation } from "../actions/sendInvitation.action";

export const useAppSendInvitationMutation = () => {

    const token = sessionStorage.getItem("token")
    return useMutation({
        mutationFn: ({ email, companyName, targetName }: any) =>
            sendInvitation({ token, email, companyName, targetName }),

        onSuccess: (data) => {
            console.log("Invitation sent:", data);
        },

        onError: (error) => {
            console.error("Invitation error:", error.message);
        },
    });
};
